import React from 'react';
import { copyFor } from 'config';
import { PageHeading } from 'components/page-heading';
import { SolarExplainer } from 'pages/solar/components/solar-explainer';
import { Grid, LeftColumnGridCell, Page, RightColumnGridCell } from 'styles';

const getCopy = copyFor('solar');

export const WithoutUtilityAccounts = () => {
  return (
    <Page small={{ padding: '0 0 24px' }}>
      <div data-testid="without-utility-accounts">
        <PageHeading page={getCopy('heading')} />
        <Grid width="100%" gap="24px">
          <LeftColumnGridCell>
            <SolarExplainer />
          </LeftColumnGridCell>
          <RightColumnGridCell></RightColumnGridCell>
        </Grid>
      </div>
    </Page>
  );
};
